import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetAdministrationSheets from "services/recordSheets/useGetAdministrationSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetDiagnosisField, SheetTextField, formatText, formatDate, buildEntornoLaboralProps } from "../SheetLayout";

const ParteSinBaja: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const parteId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { dataAdministrationSheet: d, loadingAdministrationSheet, errorAdministrationSheet, getWithoutLeavePart } = useGetAdministrationSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getWithoutLeavePart(userId, prestacionId, parteId); }, []);

  if (loadingAdministrationSheet) return <section className="container"><LoaderMin /></section>;
  if (errorAdministrationSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Parte Sin Baja"
        icon="briefcase"
        pills={<>
          <SheetPill label="Fecha hecho causante" value={formatDate(d.fechaAccidente)} icon="calendar" />
          <SheetPill label="Fecha asistencia"      value={formatDate(d.fechaAsistencia)} />
        </>}
      />

      <SheetSection title="Detalle" icon="file-text">
        <SheetGrid>
          <SheetField label="Fecha hecho causante" value={formatDate(d.fechaAccidente)} />
          <SheetField label="Fecha Asistencia"     value={formatDate(d.fechaAsistencia)} />
          <SheetField label="Centro"               value={formatText(d.centro)} wide />
          <SheetDiagnosisField label="Diagnóstico CIE 9"  code={d.codigoDiagnosticoCIE9 || ""} desc={d.diagnostico || ""} wide />
          <SheetDiagnosisField label="Diagnóstico CIE 10" code={d.codigoDiagnosticoCIE10 || ""} desc={d.diagnosticoCIE10Descripcion || ""} wide />
          <SheetTextField label="Descripción accidente" value={d.descripcionAccidente || ""} wide />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Facultativo" icon="users">
        <SheetGrid cols={3}>
          <SheetField label="Nombre médico"  value={formatText(d.nombreFacultativo)} />
          <SheetField label="Número médico"  value={formatText(d.numeroFacultativo)} />
          <SheetField label="CIAS médico"    value={formatText(d.ciasFacultativo)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default ParteSinBaja;
